module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/pin-2529559d36ebf1b1ab609ab4b95ec3e4.png";